package com.milta.core.localization.translations.sq

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Anulo",
    confirm = "Konfirmo",
    save = "Ruaj",
    delete = "Fshi",
    back = "Kthehu",
    loading = "Duke ngarkuar…",
    retry = "Provo përsëri",
    language = "Gjuha",
    welcomeTitle = "Mirë se vini në Milta",
    welcomeSubtitle = "Asistenti juaj i zgjuar i dorëzimit",
    alreadyHaveAccount = "Kam tashmë një llogari",
    createAccount = "Krijo një llogari",
    continueWithGoogle = "Vazhdo me Google",
    continueWithApple = "Vazhdo me Apple",
    oauthErrorGeneric = "Ndodhi një gabim gjatë hyrjes. Ju lutemi provoni përsëri.",
    oauthAppleWebComingSoon = "Hyrja me Apple do të jetë e disponueshme së shpejti në ueb.",
    oauthDriverAccountNotAllowedOnWeb = "Llogaritë e shoferëve nuk mund të hyjnë në panelin e uebit. Identifikohuni nga aplikacioni celular.",
    oauthAccountNotFoundOnWeb = "Nuk u gjet asnjë llogari Milta për këtë llogari Google.",
    errorOffline = "Nuk ka lidhje interneti.",
    navTourneesDuJour = "Turet e sotme",
    navAjouterUneTournee = "Shto një turne",
    navHistoriqueDesPreuves = "Historiku i dorëzimeve",
    navParametres = "Cilësimet",
    sidebarRoleManagerLabel = "Menaxher",
    noDeliveriesYetTitle = "Ende asnjë dorëzim",
    noDeliveriesYetSubtitle = "Prekni „Shto dorëzime” për të shtuar",
    optimizationUnavailableExplanation = "Dëshironi ta krijoni turin pa optimizim, apo të provoni sërish?",
    createWithoutOptimizationAction = "Krijo pa optimizim",
    gpsAppSheetTitle = "Zgjidh një aplikacion navigimi",
    addressSearchingLabel = "Duke kërkuar…",
)
